import React, {useEffect, useId, useState, useRef} from 'react';
import css from '../blogger/Blogger.module.scss';
import classNames from 'classnames';
import {useStore} from '../../../../../../store/store';
import {observer} from 'mobx-react';
import moment from 'moment';
import Navigation from '../../../../../modules/NavigationBloggers';
import {Button} from '../../../../../shared/Buttons';
import {formatNumberToCash, formatNumber2} from '../../../../../functions/formatNumber';
import {copyText} from '../../../../../functions/copyText';

const Header = ({
  page,
  setPage,
  data,
  id,
  links = [
    {link: 'settings', title: 'Настройки'},
    {link: 'telegramChannels', title: 'Телеграм каналы'},
    {link: 'analyze', title: 'Анализ Трафика'},
  ],
  settingData,
  setSettingData,
  saveSetting,
  setSaveButtonState,
  saveButtonState,
}) => {
  const store = useStore();

  const time = useRef(null);
  const intervalId = useRef(null);
  const [timeInfo, setTimeInfo] = useState('');

  const formatTimeAgo = (milliseconds) => {
    if (new Date().getTime() - milliseconds * 1000 < 3600000) {
      return moment(milliseconds * 1000)
        .startOf('minute')
        .fromNow();
    }

    return moment(milliseconds * 1000)
      .startOf('hour')
      .fromNow();
  };

  useEffect(() => {
    getNewTime(!!data.updated_at ? data.updated_at * 1000 : data.created_at * 1000);
  }, [data]);

  const getNewTime = (miliss = 0) => {
    const newTime = miliss || new Date().getTime();
    time.current = newTime;

    if (intervalId.current) {
      clearInterval(intervalId.current);
    }

    intervalId.current = setInterval(() => {
      setTimeInfo(formatTimeAgo(time.current / 1000));
    }, 1000);

    setSaveButtonState(0);
  };

  useEffect(() => {
    if (saveButtonState === 1) {
      clearInterval(intervalId.current);
      time.current = null;
    }
  }, [saveButtonState]);

  return (
    <>
      <div className='card mb-8' id='bloggerHeader'>
        <div className='card-body p-5 pb-0'>
          <div className={css.header}>
            <section className={css.bloggerData}>
              <div className={css.nameContainer}>
                <span className='text-gray-800 fs-2 fw-bold'>{data.name}</span>
                <span className={`badge badge-light-${data?.indicator?.indicator} me-auto`}>
                  {!store.roles.includes(19)
                    ? `${formatNumber2(data?.romi)}%`
                    : data?.indicator?.name}
                </span>
              </div>
              <div className={css.otherData}>
                <div className='fw-semibold fs-5 text-gray-400'>#{data?.traffic?.id}</div>
                {/* <Link to={`/sales/ltc/teams/${data?.sales_team_id}`}> */}
                <span className='d-flex align-items-center text-gray-500 me-5 mb-2 fs-5 fw-bold'>
                  <i className='ki-duotone ki-abstract-26 fs-4 me-1'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                  </i>
                  {data?.traffic?.name}
                </span>
                {/* </Link> */}
              </div>
            </section>
            <section className={css.metrics}>
              {!store.roles.includes(19) && (
                <div className='border border-gray-300 border-dashed rounded min-w-125px py-2 px-2 '>
                  <div className='d-flex align-items-center'>
                    {+data?.profit < 0 && (
                      <i className='ki-duotone ki-arrow-down fs-3 text-danger me-2'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                      </i>
                    )}
                    {+data?.profit >= 0 && (
                      <i className='ki-duotone ki-arrow-up fs-3 text-success me-2'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                      </i>
                    )}
                    <div className='fs-4 fw-bold'>{formatNumberToCash(data?.profit)}</div>
                  </div>

                  <div className='fw-semibold fs-6 text-gray-400'>Прибыль</div>
                </div>
              )}
              {!store.roles.includes(19) && (
                <div className='border border-gray-300 border-dashed rounded min-w-125px py-2 px-2 '>
                  <div className='d-flex align-items-center'>
                    <i className='ki-duotone ki-arrow-up fs-3 text-success me-2'>
                      <span className='path1'></span>
                      <span className='path2'></span>
                    </i>
                    <div className='fs-4 fw-bold'>{formatNumberToCash(data?.revenue)}</div>
                  </div>

                  <div className='fw-semibold fs-6 text-gray-400'>Доход</div>
                </div>
              )}
              <div className='border border-gray-300 border-dashed rounded min-w-125px py-2 px-2'>
                <div className='d-flex align-items-center'>
                  <i className='ki-duotone ki-arrow-down fs-3 text-danger me-2'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                  </i>
                  <div className='fs-4 fw-bold' data-kt-countup='true' data-kt-countup-value='75'>
                    {formatNumberToCash(data?.cost)}
                  </div>
                </div>

                <div className='fw-semibold fs-6 text-gray-400'>Расходы</div>
              </div>
            </section>
            <section className={css.actions}>
              <div className={css.row}>
                <div className={css.socialNetworks}>
                  {!!data?.source_link && (
                    <a
                      className={classNames(css.instagram, 'bg-light')}
                      href={data?.source_link}
                      target='blank'
                    >
                      <i className='bi bi-play-fill fs-2'></i>
                    </a>
                  )}
                  <button
                    className={classNames(css.instagram, 'bg-light')}
                    onClick={() => copyText(`https://thl.ac/inf/${id}`)}
                  >
                    <i className='ki-duotone ki-copy text-gray-500 fs-2'></i>
                  </button>
                </div>
                {saveButtonState === 0 && (
                  <>
                    <Button
                      className='text-gray-500'
                      color={'btn-light'}
                      disabled={true}
                      action={async () => {
                        // save();
                      }}
                    >
                      Сохранено
                    </Button>
                  </>
                )}
                {saveButtonState === 1 && (
                  <>
                    <Button
                      action={async () => {
                        // save();
                        saveSetting();
                      }}
                    >
                      Сохранить
                    </Button>
                  </>
                )}
              </div>
              <div className={css.row}>
                {saveButtonState === 0 && timeInfo && (
                  <>
                    {!!data?.updated_at && (
                      <span className='text-gray-500'>Обновлено {timeInfo}</span>
                    )}
                    {!data?.updated_at && <span className='text-gray-500'>Создано {timeInfo}</span>}
                  </>
                )}
                {saveButtonState === 1 && (
                  <span className='text-gray-500'>Изменения не сохранены</span>
                )}
              </div>
            </section>
          </div>

          <div className='separator'></div>
          <Navigation page={page} setPage={setPage} links={links} />
        </div>
      </div>
    </>
  );
};

export default observer(Header);
